import Header from "../components/Header";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import SubHeader from "../components/SubHeader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchJobDetails } from "../redux/actions/maintainedBoatsActions";
import { curSym } from "../auth/Pip";
import { pageRoutes } from "../routes/PageRoutes";
import PaginationDropdown from "../layout/PaginationDropdown";
import ReactPagination from "../layout/ReactPagination";

const JobDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useLocation()?.state?.data || {};
  const jobId = data?.taskId || data?.task_id || data?.id || data?.jobId;
  const [isToggle, setIsToggle] = useState(false);
  const [expandedNotes, setExpandedNotes] = useState({});
  const toggleNote = (key) => setExpandedNotes((prev) => ({ ...prev, [key]: !prev[key] }));
  const [serviceCurrentPage, setServiceCurrentPage] = useState(0);
  const [serviceRowsPerPage, setServiceRowsPerPage] = useState(5);
  const [partCurrentPage, setPartCurrentPage] = useState(0);
  const [partRowsPerPage, setPartRowsPerPage] = useState(5);
  const { isLoading2, jobData } = useSelector(
    (state) => state?.maintainedReducer,
  );
  const services = jobData?.services || [];
  const partsUsed = jobData?.partsUsed || [];
  const paginatedServices = services.slice(
    serviceCurrentPage * serviceRowsPerPage,
    (serviceCurrentPage + 1) * serviceRowsPerPage,
  );
  const paginatedPartsUsed = partsUsed.slice(
    partCurrentPage * partRowsPerPage,
    (partCurrentPage + 1) * partRowsPerPage,
  );

  useEffect(() => {
    if (jobId) {
      dispatch(fetchJobDetails(jobId));
    }
  }, [dispatch, jobId]);

  useEffect(() => {
    const totalPages = Math.ceil(services.length / serviceRowsPerPage);

    if (totalPages > 0 && serviceCurrentPage >= totalPages) {
      setServiceCurrentPage(totalPages - 1);
    }

    if (totalPages === 0 && serviceCurrentPage !== 0) {
      setServiceCurrentPage(0);
    }
  }, [services.length, serviceRowsPerPage, serviceCurrentPage]);

  useEffect(() => {
    const totalPages = Math.ceil(partsUsed.length / partRowsPerPage);

    if (totalPages > 0 && partCurrentPage >= totalPages) {
      setPartCurrentPage(totalPages - 1);
    }

    if (totalPages === 0 && partCurrentPage !== 0) {
      setPartCurrentPage(0);
    }
  }, [partsUsed.length, partRowsPerPage, partCurrentPage]);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="job-details" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div className="ct_px_23 ct_mt_30 pb-5">
            <div className="d-flex justify-content-between ct_flex_wrap_767 gap-3 ct_mb_30">
              <SubHeader />

              {jobData?.jobOverview?.status?.label == "COMPLETED" && (
                <div className="d-flex ct_flex_wrap_575 gap-3 align-items-center ct_w_100_767">
                  <a
                    onClick={() =>
                      navigate(pageRoutes?.invoice_detail, {
                        state: {
                          invoice_id: jobData?.invoice?.invoiceId,
                          boat_id: jobData?.meta?.boatId,
                        },
                      })
                    }
                    class="ct_orange_btn ct_grey_btn ct_w_100_575 flex-grow-1  ct_w_100_767"
                  >
                    <svg
                      className="me-2"
                      width="22"
                      height="15"
                      viewBox="0 0 22 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
                        stroke="white"
                        stroke-width="1.57885"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
                        stroke="white"
                        stroke-width="1.57885"
                        stroke-linejoin="round"
                      />
                    </svg>
                    View Invoice
                  </a>
                </div>
              )}
            </div>

            <div class="">
              <div class="">
                {/* content */}

                <div class="row">
                  <div class="col-xl-8 mb-3">
                    <div class="ct_white_bg_1 h-100">
                      <div class="d-flex justify-content-between mb-4">
                        <h3 class="ct_fs_18 ct_fw_600 ct_text_dark mb-0">
                          Job Overview
                        </h3>
                        <div class="d-flex align-items-center gap-3">
                          <span
                            class="active-dot"
                            style={{
                              backgroundColor:
                                jobData?.jobOverview?.status?.color,
                            }}
                          ></span>
                          <span
                            class="ct_active_badge text-capitalize"
                            style={{
                              color: jobData?.jobOverview?.status?.color,
                            }}
                          >
                            {jobData?.jobOverview?.status?.label?.toLowerCase()}
                          </span>
                        </div>
                      </div>

                      <div class="row gy-3">
                        <div class="col-xl-3 col-md-6">
                          <p class="ct_text_para ct_fw_400 ct_fs_14 mb-1">
                            BOAT NAME
                          </p>
                          <h5 class="ct_fs_16 ct_fw_400 ct_text_dark mb-0">
                            {jobData?.jobOverview?.boatName || "-"}
                          </h5>
                        </div>
                        <div class="col-xl-3 col-md-6">
                          <p class="ct_text_para ct_fw_400 ct_fs_14 mb-1">
                            DOCK LOCATION
                          </p>
                          <h5 class="ct_fs_16 ct_fw_400 ct_text_dark mb-0">
                            {jobData?.jobOverview?.dockLocation || "-"}
                          </h5>
                        </div>
                        <div class="col-xl-3 col-md-6">
                          <p class="ct_text_para ct_fw_400 ct_fs_14 mb-1">
                            CREATED DATE
                          </p>
                          <h5 class="ct_fs_16 ct_fw_400 ct_text_dark mb-0">
                            {jobData?.jobOverview?.createdDate || "-"}
                          </h5>
                        </div>
                        <div class="col-xl-3 col-md-6">
                          <p class="ct_text_para ct_fw_400 ct_fs_14 mb-1">
                            JOB ID
                          </p>
                          <h5 class="ct_fs_16 ct_fw_400 ct_text_dark mb-0">
                            {jobData?.jobOverview?.jobId || "-"}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 mb-3">
                    <div class="ct_white_bg_1 h-100">
                      <h5 class="ct_fs_14 ct_fw_400 ct_text_dark mb-3">
                        Assigned User
                      </h5>

                      <div class="d-flex gap-2">
                        <div>
                          <img
                            src={
                              jobData?.assignedUser?.profileImage ||
                              "user_profile.png"
                            }
                            class="ct_h_64_w_64 ct_border_radius_12"
                          />
                        </div>
                        <div>
                          <h5 class="ct_fs_16 ct_fw_400 ct_text_dark mb-1">
                            {jobData?.assignedUser?.name || "-"}
                          </h5>
                          <h6 class="ct_fs_12 ct_fw_400 ct_blue_text mb-1">
                            {jobData?.assignedUser?.type || "-"}
                          </h6>
                          <p class="ct_fs_12 ct_fw_400 ct_text_dark mb-0" style={{ wordBreak: "break-word" }}>
                            {jobData?.assignedUser?.email || "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* table */}
                <div class="ct_white_bg p-4 ct_border_radius_12 ct_mt_25">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="ct_fs_18 ct_fw_600 mb-0">Services</h4>
                    <span className="ct_fs_14 ct_fw_500 ct_text_para">
                      Estimated Quoted Value: <strong className="ct_blue_text">{curSym}{Number(jobData?.meta?.quotedValue || 0).toFixed(2)}</strong>
                    </span>
                  </div>
                  <div class="custom_table_wrapper">
                    <div class="table-responsive ct_custom_table ct_job_mangment_detail_table">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>SERVICE NAME</th>

                            {/* <th>DESCRIPTION</th> */}
                            <th>COST</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedServices?.length > 0 ? (
                            paginatedServices?.map((item, i) => (
                              <tr key={item?.id || `${item?.serviceName || "service"}-${i}`}>
                                <td class="ct_text_para">
                                  {item?.serviceName || "-"}
                                </td>
                                {/* <td class="ct_text_para">
                                  <p class="table_description ct_fs_16 mb-0 ct_overlay_text">
                                    {item?.description || "-"}
                                  </p>
                                </td> */}
                                <td class="">
                                  <span class="ct_blue_text">
                                    {" "}
                                    {curSym} {item?.cost || "-"}
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                className="text-center bg-transparent border-0"
                                colSpan="7"
                              >
                                <div className="text-center">
                                  <p className="mb-0 mt-3 ct_fs_18 ct_fw_700 ct_ff_poppin ct_clr_8C98A9 text-center">
                                    No record found
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>


                    {/* Assign  technician modal */}

                    <div
                      class="modal fade"
                      id="ct_assign_technician_modal_post"
                      tabindex="{-1}"
                      aria-labelledby="ct_assign_technician_postLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-lg modal-dialog-centered">
                        <div class="modal-content ct_border_radius_20">
                          <div class="modal-body">
                            <div class="ct_delete_post_modal p-4">
                              <figure>
                                <figcaption>
                                  <div class="d-flex justify-content-between align-items-start">
                                    <div class="">
                                      <h4 class="ct_fs_24 ct_fw_600 ct_blue_text mb-2">
                                        Assign Technician/Supplier
                                      </h4>
                                      <p class="mb-0 ct_text_para ct_fs_16">
                                        Choose user and schedule the job for
                                        execution.
                                      </p>
                                    </div>
                                    <div
                                      data-bs-dismiss="modal"
                                      class="ct_pointer"
                                    >
                                      <i class="fa-solid fa-xmark"></i>
                                    </div>
                                  </div>
                                </figcaption>

                                <form class="mt-5">
                                  <div class="row">
                                    <div class="col-lg-6">
                                      <div class="form-group mb-3">
                                        <label class="form-label">
                                          Assign To
                                        </label>
                                        <select
                                          class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                          id="boatId"
                                        >
                                          <option value="">Technician</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-lg-6">
                                      <div class="form-group mb-3">
                                        <label class="form-label">
                                          Select Technician
                                        </label>
                                        <select
                                          class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                          id="boatId"
                                        >
                                          <option value="">Select</option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-lg-6">
                                      <div class="form-group mb-3">
                                        <label class="form-label">
                                          Start Date
                                        </label>
                                        <input
                                          type="date"
                                          class="form-control ct_input ct_transparent_input"
                                        />
                                      </div>
                                    </div>

                                    <div class="col-lg-6">
                                      <div class="form-group">
                                        <label class="form-label">
                                          {" "}
                                          End Date{" "}
                                        </label>
                                        <input
                                          type="date"
                                          class="form-control ct_input ct_transparent_input"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </figure>
                              <div class="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                                <a
                                  data-bs-dismiss="modal"
                                  class="ct_border_radius_5 ct_h_40 ct_orange_btn px-5 text-center ct_pointer"
                                >
                                  Assign
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  */}
                  </div>
                </div>
                {services.length > 0 && (
                  <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mt-3">
                    <PaginationDropdown
                      onChange={(val) => {
                        setServiceRowsPerPage(Number(val));
                        setServiceCurrentPage(0);
                      }}
                    />
                    <ReactPagination
                      pageCount={Math.ceil(services.length / serviceRowsPerPage)}
                      onPageChange={(data) => setServiceCurrentPage(data.selected)}
                      currentPage={serviceCurrentPage}
                    />
                  </div>
                )}

                <div class="row ct_mt_25">
                  <div class="col-xxl-8 col-xl-8 col-lg-6 col-md-6 mb-4">
                    <div class="ct_white_bg p-4 ct_border_radius_12">
                      <h3 class="mb-3 ct_fs_18 ct_fw_400">Parts Used</h3>
                      <div class="custom_table_wrapper">
                        <div class="table-responsive ct_custom_table ct_job_mangment_detail_table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>PART NAME</th>
                                <th>QUANTITY</th>
                                <th>COST</th>
                                <th>INSTALLED DATE</th>
                                <th>WARRANTY START DATE</th>
                                <th>NOTES</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedPartsUsed?.length > 0 ? (
                                paginatedPartsUsed?.map((item, i) => (
                                  <tr key={item?.id || `${item?.partName}-${i}`}>
                                    <td className="ct_text_para ct_text_wrap_250">
                                      {item?.partName || "-"}
                                    </td>

                                    <td className="ct_text_para text-center">
                                      {item?.quantity || "-"}
                                    </td>

                                    <td className="text-center">
                                      <span className="ct_blue_text">
                                        {item?.cost ? `${curSym} ${item.cost}` : "-"}
                                      </span>
                                    </td>

                                    <td className="ct_text_para text-center">
                                      {item?.installedDate || "-"}
                                    </td>

                                    <td className="ct_text_para text-center">
                                      {item?.warrantyStartDate || "-"}
                                    </td>

                                    <td>
                                      {(() => {
                                        const noteKey = item?.id || `note-${i}`;
                                        const noteText = item?.notes || "";
                                        const isLong = noteText.length > 120;
                                        const isExpanded = expandedNotes[noteKey];
                                        if (!noteText) return <span className="ct_text_para">-</span>;
                                        return (
                                          <div className="ct_notes_wrapper">
                                            <div className={isExpanded ? "ct_notes_expanded" : "ct_notes_collapsed"}>
                                              {noteText}
                                            </div>
                                            {isLong && (
                                              <button
                                                className="ct_view_more_btn"
                                                onClick={() => toggleNote(noteKey)}
                                              >
                                                {isExpanded ? "View Less" : "View More"}
                                              </button>
                                            )}
                                          </div>
                                        );
                                      })()}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    className="text-center bg-transparent border-0"
                                    colSpan="7"
                                  >
                                    <div className="text-center">
                                      <p className="mb-0 mt-3 text-center">
                                        No record found
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>


                        {/* Assign  technician modal */}

                        <div
                          class="modal fade"
                          id="ct_assign_technician_modal_post"
                          tabindex="{-1}"
                          aria-labelledby="ct_assign_technician_postLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog modal-lg modal-dialog-centered">
                            <div class="modal-content ct_border_radius_20">
                              <div class="modal-body">
                                <div class="ct_delete_post_modal p-4">
                                  <figure>
                                    <figcaption>
                                      <div class="d-flex justify-content-between align-items-start">
                                        <div class="">
                                          <h4 class="ct_fs_24 ct_fw_600 ct_blue_text mb-2">
                                            Assign Technician/Supplier
                                          </h4>
                                          <p class="mb-0 ct_text_para ct_fs_16">
                                            Choose user and schedule the job for
                                            execution.
                                          </p>
                                        </div>
                                        <div
                                          data-bs-dismiss="modal"
                                          class="ct_pointer"
                                        >
                                          <i class="fa-solid fa-xmark"></i>
                                        </div>
                                      </div>
                                    </figcaption>

                                    <form class="mt-5">
                                      <div class="row">
                                        <div class="col-lg-6">
                                          <div class="form-group mb-3">
                                            <label class="form-label">
                                              Assign To
                                            </label>
                                            <select
                                              class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                              id="boatId"
                                            >
                                              <option value="">
                                                Technician
                                              </option>
                                            </select>
                                          </div>
                                        </div>
                                        <div class="col-lg-6">
                                          <div class="form-group mb-3">
                                            <label class="form-label">
                                              Select Technician
                                            </label>
                                            <select
                                              class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                              id="boatId"
                                            >
                                              <option value="">Select</option>
                                            </select>
                                          </div>
                                        </div>

                                        <div class="col-lg-6">
                                          <div class="form-group mb-3">
                                            <label class="form-label">
                                              Start Date
                                            </label>
                                            <input
                                              type="date"
                                              class="form-control ct_input ct_transparent_input"
                                            />
                                          </div>
                                        </div>

                                        <div class="col-lg-6">
                                          <div class="form-group">
                                            <label class="form-label">
                                              End Date
                                            </label>
                                            <input
                                              type="date"
                                              class="form-control ct_input ct_transparent_input"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </figure>
                                  <div class="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                                    <a
                                      data-bs-dismiss="modal"
                                      class="ct_border_radius_5 ct_h_40 ct_orange_btn px-5 text-center ct_pointer"
                                    >
                                      Assign
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*  */}
                      </div>
                    </div>
                    {partsUsed.length > 0 && (
                      <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mt-3">
                        <PaginationDropdown
                          onChange={(val) => {
                            setPartRowsPerPage(Number(val));
                            setPartCurrentPage(0);
                          }}
                        />
                        <ReactPagination
                          pageCount={Math.ceil(partsUsed.length / partRowsPerPage)}
                          onPageChange={(data) => setPartCurrentPage(data.selected)}
                          currentPage={partCurrentPage}
                        />
                      </div>
                    )}
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-6 col-md-6 mb-4">
                    <div class="ct_white_bg ct_dash_card active h-auto d-block">
                      <div>
                        <div class="mb-4 pb-2">
                          <span class=" ct_fs_22 ct_fw_600">
                            Cost Summary
                          </span>
                        </div>
                        <div class="d-flex justify-content-between mb-3 align-items-start">
                          <span>Services Total</span>
                          <span>
                            {curSym}
                            {Number(jobData?.costSummary?.servicesTotal || 0).toFixed(2)}
                          </span>
                        </div>
                        <div class="d-flex justify-content-between mb-3 align-items-start">
                          <span>Parts Total</span>
                          <span>
                            {curSym}
                            {Number(jobData?.costSummary?.partsTotal || 0).toFixed(2)}
                          </span>
                        </div>
                        {Number(jobData?.costSummary?.wasteFee || 0) > 0 && (
                          <div class="d-flex justify-content-between mb-3 align-items-start">
                            <span>Waste Management Fee</span>
                            <span>
                              {curSym}
                              {Number(jobData?.costSummary?.wasteFee).toFixed(2)}
                            </span>
                          </div>
                        )}
                        <div class="d-flex justify-content-between mb-3 align-items-start">
                          <span>Subtotal</span>
                          <span>
                            {curSym}
                            {Number(jobData?.costSummary?.subtotal || 0).toFixed(2)}
                          </span>
                        </div>
                        <div class="d-flex justify-content-between align-items-start">
                          <span>GST (10%)</span>
                          <span>
                            {curSym}
                            {Number(jobData?.costSummary?.gstAmount || 0).toFixed(2)}
                          </span>
                        </div>
                      </div>
                      <div className="mt-auto">
                        <div className="border_bottom_5A413633 my-3"></div>
                        <div className="d-flex justify-content-between align-items-start">
                          <span className="ct_fs_14">GRAND TOTAL</span>
                          <div className="text-end">
                            <span className="ct_fs_30 ct_fw_400 d-block">
                              {curSym}
                              {Number(jobData?.costSummary?.grandTotal || 0).toFixed(2)}
                            </span>
                            {jobData?.costSummary?.taxIncluded && (
                              <span className="tax_include_btn mt-1 d-inline-block">TAX INCL.</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* content end */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetail;
